import styled from 'styled-components';

export const DocumentContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 1rem;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 50vh;
  font-size: 1.5rem;
  font-family: metropolis;
`;

export default {
  DocumentContainer,
  LoadingContainer,
};
